import { inject, Injectable } from '@angular/core';
import { ApiDependencyProviderService } from '@web/common';
import { map, Observable } from 'rxjs';
import { blank, valueOrDefault } from '@web/utils';
import { AdminCartSettingsUpdateRequest } from '../requests/admin-cart-settings-update.request';
import { AdminCartSettingsResponse } from '../responses/admin-cart-settings.response';

@Injectable({
  providedIn: 'root',
})
export class AdminCartApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  public fetchSettings(options: {
    skipByLoading?: boolean;
  }): Observable<AdminCartSettingsResponse> {
    const path = 'admin/settings/cart';
    const url = this.provider.httpUrlFactory.withQueryParams(
      this.hostUrl(),
      path,
      {},
    );
    const context = this.provider.httpContextBuilder
      .skipByHttpErrorInterceptor()
      .withOptionalSkipByLoadingInterceptor(() =>
        valueOrDefault(options?.skipByLoading, false),
      )
      .build();

    return this.provider.http
      .get(url, { context })
      .pipe(
        map(
          this.provider.httpHelper.bodyToResponse(AdminCartSettingsResponse),
        ),
      );
  }

  public updateSettings(
    request: AdminCartSettingsUpdateRequest,
  ): Observable<void> {
    const path = 'admin/settings/cart';
    const url = this.provider.httpUrlFactory.withQueryParams(
      this.hostUrl(),
      path,
      {},
    );
    const body = this.provider.httpHelper.requestToBody(
      request,
      AdminCartSettingsUpdateRequest,
    );
    const context = this.provider.httpContextBuilder
      .skipByHttpErrorInterceptor()
      .build();

    return this.provider.http.put(url, body, { context }).pipe(blank());
  }

  private hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Shop;
  }
}
